import { DoubleSide, MeshBasicMaterial, type Texture } from 'three';
import type { BaseMaterialParams } from '@/lib/threeScene/materials/params';

/** Default color for solid material */
const DEFAULT_COLOR = '#ffffff' as const;

/** The default is for materials to apply to both front- and back-sides of an object */
const DEFAULT_SIDE = DoubleSide;

/** Default opacity is to be fully opaque i.e. not transparent at all */
const DEFAULT_OPACITY = 1.0 as const;

export type BasicMaterialParams = BaseMaterialParams & {
    type: 'basic';
    map: Texture | null;
};

/**
 * Create a three.js {@link MeshBasicMaterial}; this kind of material appears as a simple
 * flat colour, texture, or wireframe without any shadowing or highlights caused by lights
 * in the scene.
 */
export function makeBasicMaterial(params?: Partial<BasicMaterialParams>): MeshBasicMaterial {
    const transparent = params?.transparent ?? false;
    return new MeshBasicMaterial({
        name: params?.name ?? 'basic',
        color: params?.color ?? DEFAULT_COLOR,
        side: params?.side ?? DEFAULT_SIDE,
        clippingPlanes: params?.clippingPlanes ?? [],
        opacity: params?.opacity ?? DEFAULT_OPACITY,
        transparent,
        depthWrite: !transparent,
        vertexColors: params?.vertexColors ?? false,
        map: params?.map ?? null,
    });
}
